export enum StockType {
  PRIVATE = 'PRIVATE',
  STOCK = 'STOCK',
  UNREGISTERED = 'UNREGISTERED',
  WARRANT = 'WARRANT',
  CVR = 'CVR',
  BASKET_SWAP = 'BASKET_SWAP',
  SAFE = 'SAFE',
  CONVERTIBLE_NOTE = 'CONVERTIBLE_NOTE',
}
